import { Box, Button, Typography } from '@mui/material';
import AddCommunityMember from '../Communities/AddCommunityMemberWidget';
import useStore from '../state-files/zustondStoreStates';
import RemoveCommunityMember from '../Communities/RemoveCommunityMember';
import { apiUrlPrefix } from '../../../config';
import fetchCommunities from '../helper-methods/fetchCommunities';

const CommunityDiscussionComponent = () => {
    const { currentCommunityId, currentCommunityName, isCommunityAdmin } = useStore(); // Use zustand store
    const { greenButtonSX, setCommunities } = useStore();

    const leaveCommunity = async () => {
        const apiUrl = apiUrlPrefix + 'Communities/leaveCommunity';

        const response = await fetch(apiUrl, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                Users: [localStorage.getItem('userId')], // Send the array directly
                Id: currentCommunityId,
            }),
        });

        if (!response.ok) {
            if (response.status === 403) {
                throw new Error('Unable to leave community.');
            }
            throw new Error('Network response was not ok');
        }
        return response.status;
    };

    return (
        <>
            <Box
                className={currentCommunityId.length > 0 ? "" : "hidden"}
                sx={{
                    display: 'flex',
                    alignItems: { xs: 'center' },    // Center children horizontally
                    justifyContent: { xs: 'center' }, // Center children vertically
                    width: '90%',
                    backgroundColor: 'rgba(40, 165, 52, 0.3)',
                    p: '15px 20px',
                    mb: '10px',
                    borderRadius: '5px',
                    gap: 1.5 // Space between the Title and the Button
                }}
            >
                <Typography variant="h5" sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                    {currentCommunityName}
                </Typography>
            </Box>
            <Box
                className={currentCommunityId.length > 0 ? "" : "hidden"}
                sx={{
                    display: 'flex',       // Enables flex alignment
                    flexDirection: 'row',
                    justifyContent: 'center', // Centers button horizontally
                    width: '100%',         // Takes full width to allow centering
                    mb: 2,
                    gap: '5vw'
                }}
            >
                <Box sx={[greenButtonSX, {display: isCommunityAdmin ? '' : 'none'}]}>
                    <AddCommunityMember
                        isBold={true}
                    />
                </Box>

                <Box sx={[greenButtonSX, {display: isCommunityAdmin ? '' : 'none'}]}>
                    <RemoveCommunityMember
                        isBold={true}
                    />
                </Box>

                <Box sx={greenButtonSX}>
                    <Button
                        id="leaveCommunityMemberButton"
                        variant="contained"
                        color="none"
                        onClick={async () => {
                            const response = await leaveCommunity();
                            if (response === 200) {
                                fetchCommunities(setCommunities);
                            }
                        }}
                        style={{ boxShadow: 'none' }}
                    > Leave Community </Button>
                </Box>
            </Box>
        </>
    )
};

export default CommunityDiscussionComponent;